export default "__VITE_ASSET__CumMyD4q__"